import React , { useEffect , useState } from 'react';
import Header from "../header/header";
import Footer from "../footer/footer";
import "./layout.css"
import Messenger from "../messenger/messenger";
import Api from "../../services/api";
import {useDispatch} from "react-redux";
import {setting} from "../../redux/action"
const Layout = (props) => {

    const dispatch = useDispatch()

    useEffect(() => {
        getSetting()
    }, []);

    const getSetting = () => {
        new Api().get("/setting")
            .then((res) => {
                dispatch(setting(res))
            })
    }

    return (
        <>
            <div className={"flag"}>
                <div/>
                <div/>
                <div/>
            </div>
            <Header/>
            {props.children}
            <Footer/>
            <Messenger/>
        </>
    );
};

export default Layout;

